// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumEnvironmentState } from './EnumEnvironmentState';
import {
  EnumEnvironmentStateFromJSON,
  EnumEnvironmentStateFromJSONTyped,
  EnumEnvironmentStateToJSON,
  EnumEnvironmentStateToJSONTyped,
} from './EnumEnvironmentState';
import type { ResponseEnvironmentStatusEvent } from './ResponseEnvironmentStatusEvent';
import {
  ResponseEnvironmentStatusEventFromJSON,
  ResponseEnvironmentStatusEventFromJSONTyped,
  ResponseEnvironmentStatusEventToJSON,
  ResponseEnvironmentStatusEventToJSONTyped,
} from './ResponseEnvironmentStatusEvent';
import type { ResponseEnvironmentStatusOperation } from './ResponseEnvironmentStatusOperation';
import {
  ResponseEnvironmentStatusOperationFromJSON,
  ResponseEnvironmentStatusOperationFromJSONTyped,
  ResponseEnvironmentStatusOperationToJSON,
  ResponseEnvironmentStatusOperationToJSONTyped,
} from './ResponseEnvironmentStatusOperation';

/**
 *
 * @export
 * @interface ResponseEnvironmentStatus
 */
export interface ResponseEnvironmentStatus {
  /**
   *
   * @type {Array<ResponseEnvironmentStatusEvent>}
   * @memberof ResponseEnvironmentStatus
   */
  events?: Array<ResponseEnvironmentStatusEvent>;
  /**
   *
   * @type {Array<ResponseEnvironmentStatusOperation>}
   * @memberof ResponseEnvironmentStatus
   */
  operations?: Array<ResponseEnvironmentStatusOperation>;
  /**
   *
   * @type {EnumEnvironmentState}
   * @memberof ResponseEnvironmentStatus
   */
  state?: EnumEnvironmentState;
}

/**
 * Check if a given object implements the ResponseEnvironmentStatus interface.
 */
export function instanceOfResponseEnvironmentStatus(
  value: object,
): value is ResponseEnvironmentStatus {
  return true;
}

export function ResponseEnvironmentStatusFromJSON(
  json: any,
): ResponseEnvironmentStatus {
  return ResponseEnvironmentStatusFromJSONTyped(json, false);
}

export function ResponseEnvironmentStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentStatus {
  if (json == null) {
    return json;
  }
  return {
    events:
      json['events'] == null
        ? undefined
        : (json['events'] as Array<any>).map(
            ResponseEnvironmentStatusEventFromJSON,
          ),
    operations:
      json['operations'] == null
        ? undefined
        : (json['operations'] as Array<any>).map(
            ResponseEnvironmentStatusOperationFromJSON,
          ),
    state:
      json['state'] == null
        ? undefined
        : EnumEnvironmentStateFromJSON(json['state']),
  };
}

export function ResponseEnvironmentStatusToJSON(
  json: any,
): ResponseEnvironmentStatus {
  return ResponseEnvironmentStatusToJSONTyped(json, false);
}

export function ResponseEnvironmentStatusToJSONTyped(
  value?: ResponseEnvironmentStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    events:
      value['events'] == null
        ? undefined
        : (value['events'] as Array<any>).map(
            ResponseEnvironmentStatusEventToJSON,
          ),
    operations:
      value['operations'] == null
        ? undefined
        : (value['operations'] as Array<any>).map(
            ResponseEnvironmentStatusOperationToJSON,
          ),
    state: EnumEnvironmentStateToJSON(value['state']),
  };
}
